function intersectNode (node, point) {
  return node.intersect(point)
}

export default intersectNode
